import { APP_CONFIG } from "@shared/config"
import { Asset } from "./Asset"

interface Props {
    mini?: boolean
}
export function AppLogo({mini}: Props){
    const {appName} = APP_CONFIG
    let [width, height] = mini 
        ? ['40px', '40px']
        : ['auto', 'auto'] 
    return (
        <Asset 
            imgProps={{
                alt: 'app-logo'
            }}
            namespace="images" 
            filename={`logo/${appName}${mini ? '_mini' : ''}.svg`}
            h={height} 
            w={width}
        />
    )
}